var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 63,
    viewBox: "0 0 76 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4512 22.8828V52.383L47.6799 48.267V25.9346L39.4512 22.8828Z",
    fill: "#515151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6661 14.4354V19.8384C25.2251 18.5941 22.2714 16.0543 21.9837 15.8488C10.8175 7.5642 -5.7517 24.4936 3.6135 39.622C11.1057 51.7247 21.6235 46.5858 25.9459 42.5036C25.9459 42.5036 26.3067 47.1862 25.5857 50.0678C25.2252 51.5086 25.2261 52.5892 23.4251 53.6698C18.5264 55.6869 15.8609 52.8293 15.1405 51.1484L2.89371 49.3474C2.89371 57.2718 2.53351 61.234 19.4629 62.6748C33.5107 63.035 39.6335 56.1912 39.6335 52.229V23.0528H50.4395V47.9066C50.4397 49.5875 51.2325 53.4537 54.4023 55.4708C57.5721 57.4879 62.9266 57.752 65.2077 57.632H75.2933V45.3852H69.5301C68.4501 45.3852 67.0093 44.8089 67.0093 41.0628C67.0093 37.3167 67.249 27.4953 67.3689 23.0528H75.2933V14.408H67.3689V0.3602L50.4395 0V14.408L26.6661 14.4354ZM25.9459 30.9772C25.9459 24.7592 15.8301 19.0041 14.7797 28.4558C13.3387 41.423 25.9459 41.0628 25.9459 30.9772Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/gt.1168d3434ceb4423f965fc0f031ed42c.svg";
export { ForwardRef as ReactComponent };